import React from "react";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import moreWays1 from '../assets/images/PayYourWay.png'
import moreWays2 from '../assets/images/CustomArtwork.png'
import moreWays3 from '../assets/images/Inclusive.png'
import moreWays4 from '../assets/images/moreway_left_img.png'


export default function MoreWaysToPay() {
  return (
    <>
      {/* <div className="aboutusboxMaine"> */}
      <Container>
        <div className="moreWaysBox">
          <Row>
            <Col className="mt-auto" lg={7}>

              <Row>
                <Col className=" mb-2 text-center" md={6} sm={6} lg={12}>
                  <img src={moreWays4} className="img4" alt="" />
                </Col>
              </Row>
            </Col>
            <Col lg={5} className="">

              <div className="panelHead">
                <h3>More ways to pay,<br></br> more ways to create!</h3>
              </div>
              <p>We’ve made it easier for everyone — now you can commission custom artworks from artists and pay securely with Credit & Debit Cards in addition to Crypto.</p>
              <div className="Img_box">
                <div className="img_col">
                  <img src={moreWays1} alt="" />
                </div>
                <div className="contentBox">
                  <h3>Pay Your Way</h3>
                  <p className="moreWays_txt">Choose from Credit Card, Debit Cards, or Crypto for safe and seamless transactions.</p>
                </div>
              </div>

              <div className="Img_box">
                <div className="img_col">
                  <img src={moreWays2} alt="" />
                </div>
                <div className="contentBox">
                  <h3>Custom Artwork Requests</h3>
                  <p className="moreWays_txt">Collaborate with artist to bring your unique vision life.</p>
                </div>
              </div>

              <div className="Img_box">
                <div className="img_col">
                  <img src={moreWays3} alt="" />
                </div>
                <div className="contentBox">
                  <h3>Inclusive for All</h3>
                  <p className="moreWays_txt">Whether you’re a collector or an artist, we’ve got you covered.</p>
                </div>
              </div>

              

            </Col>

          </Row>
        </div>
      </Container>
      {/* </div> */}
    </>
  )
}